module.exports = {
  label: {
    headerTitle: 'Questionnaire Questions',
    AddheaderTitle: 'Add Questionnaire',
    questionnaire: 'Questionnaire',
    search: 'Search...',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      delete: 'Delete'
    }
  }
}
